<template>
  <Drawer title="超时报警" width="1024"  :closable="false" v-model="_value">

    <Skeleton animated>
      <List item-layout="vertical">
        <ListItem v-for="item in data" :key="item.title">
          <ListItemMeta :title="item.title"/>
          {{ item.description }}<br/>
          {{ item.content }}<br/>
          {{ item.dispose }}
          <Button v-if="item.pdfSrc" type="primary" size="small" @click="openpdf(item.pdfSrc)" style="margin: 10px;">详细文档</Button>
          <iframe-modal v-model="Iframemodal" :initValue="IframeId"></iframe-modal>
          <template #extra>
            <img :src="item.imgSrc" style="width: 580px">
          </template>
        </ListItem>
      </List>
    </Skeleton>

  </Drawer>
</template>

<script>

/**
   * 引入自建组件/框架组件等位置
   */
import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import IframeModal from '@/view/om/technicalassistance/components/iframe-modal'

export default {
  name: 'overtimedrivingalarmmodal',
  /**
     * 与组件引入的组件名一致，使用该组件
     * 下面是引入自建组件例子
     */
  components: {
    IframeModal
  },
  /**
     * 作为组件对应传送字段
     */
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    },

    Iframemodal: false,
    IframeId: false
  },
  /**
     * 默认数据/字段名创建
     */
  data () {
    return {
      /**
         * 下面是引入自建组件例子
         */
      maintainOrderAddMaintainDeviceRecordModal: false,
      maintainOrderAddMaintainDeviceRecordId: false,

      data: [
        {
          title: '超时报警',
          description: '1、ERP历史定位数据管理/易流轨迹回放查询，出现报警：疲劳驾驶报警',
          content: '2、查询速度为0km/h的数据时间有无连续20分钟以上',
          dispose: '3、重新停车休息20分钟以上',
          imgSrc: '/FAQ/overtimedrivingalarm.png'
        }
      ]
    }
  },
  /**
   * 方法存储位置
   */
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    openpdf (e) {
      this.Iframemodal = true
      this.IframeId = e
    }
  },
  /** 作为组件的数值传输字段
     */
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  /**
   * 页面加载执行的代码
   * 可调用方法存储位置中的方法
   */
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<!--样式库-->
<style scoped>
</style>
